import React from "react";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Button, Stack, Typography } from "@mui/material";

interface ManifestPreviewHeaderProps {
  serviceCount: number;
  kind: string;
  copied: boolean;
  onRefresh: () => void;
  onCopy: () => void;
  onDownload: () => void;
}

export function ManifestPreviewHeader({
  serviceCount,
  kind,
  copied,
  onRefresh,
  onCopy,
  onDownload,
}: ManifestPreviewHeaderProps): React.ReactElement {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          Manifest Preview
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {serviceCount} service{serviceCount !== 1 ? "s" : ""} · {kind}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
        >
          Refresh
        </Button>
        <Button
          size="small"
          variant="outlined"
          startIcon={<ContentCopyIcon />}
          onClick={onCopy}
        >
          {copied ? "Copied!" : "Copy YAML"}
        </Button>
        <Button
          size="small"
          variant="outlined"
          startIcon={<DownloadIcon />}
          onClick={onDownload}
        >
          Download
        </Button>
      </Stack>
    </Stack>
  );
}

export default ManifestPreviewHeader;
